import { Map } from 'immutable'
import {
  SET_USER_EMAIL_AVAILABILITY,
  SET_USER_EMAIL_AVAILABILITY_PROCESSING,
  RESET_USER_EMAIL_AVAILABILITY,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_USER_EMAIL_AVAILABILITY:
      return state.withMutations((mutateState) => mutateState
        .setIn(['emailAvailable'], payload)
        .deleteIn(['emailAvailabilityProcessing']))
    case SET_USER_EMAIL_AVAILABILITY_PROCESSING:
      return state.setIn(['emailAvailabilityProcessing'], payload)
    case RESET_USER_EMAIL_AVAILABILITY:
      return state.deleteIn(['emailAvailable'])
        .deleteIn(['emailAvailabilityProcessing'])
    default:
      return state
  }
}
